import { render, staticRenderFns } from "./submitInfo.vue?vue&type=template&id=242f4ca8&scoped=true&"
import script from "./submitInfo.vue?vue&type=script&lang=js&"
export * from "./submitInfo.vue?vue&type=script&lang=js&"
import style0 from "./submitInfo.vue?vue&type=style&index=0&id=242f4ca8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242f4ca8",
  null
  
)

export default component.exports